import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class ELKCourseAPI extends BaseAPI {}

export default new ELKCourseAPI('v1/elastic-courses', 'Course')
